import { returnPath } from "~/features/common/utils/navigation/returnPath";

export const getIndexPath = returnPath("/jobs");

export const getJobListTemplatesPath = returnPath("/jobs/job-list-templates");

export const getEventJobsPath = returnPath("/jobs/event-jobs");
export const getMinePath = returnPath("/jobs/mine");
export const getCarJobsPath = returnPath("/jobs/car-jobs");